

















import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import Container from '@/components/layout/Container.vue';
import SupportInfoIcon from '@/components/homescapes/hs000v1/SupportInfoIcon.vue';
import SupportInfoText from '@/components/homescapes/hs000v1/SupportInfoText.vue';
import FlatButton from '@/components/common/FlatButton.vue';

import LocaleMixin from '@/mixins/locale';

import { buildHelpshiftUrl } from '@/helpers/external';

@Component({ components: { FlatButton, Container, SupportInfoIcon, SupportInfoText } })
export default class SupportInfo extends mixins(LocaleMixin) {
  get url() {
    return buildHelpshiftUrl(this.locale);
  }
}
